import { useContext } from 'react';

import { AppBootstrapContext, type AppBootstrapContextValue } from '@/providers/AppBootstrapProvider.context';

export function useAppBootstrap(): AppBootstrapContextValue {
    const context = useContext(AppBootstrapContext);

    if (!context) {
        throw new Error('useAppBootstrap must be used within AppBootstrapProvider');
    }

    return context;
}
